var logger = {};

export { logger as __exports };
//# sourceMappingURL=logger.js.map
